module.exports = __webpack_public_path__ + "media/assets/images/facebook-logo-black-4d4460260f64103d8da4a91d8e856d36.svg";